import Badge from '@components/Badge';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { OrderLogRow } from '@models/order/orderLog';
import { Link } from '@router/Link';
import { pressActionEffect } from '@styles/mixin';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

interface Props {
    order: OrderLogRow;
}

function OrderLog({ order }: Props) {
    const { t } = useTranslation('orderLogs');
    const {
        status, shopName, orderName, optionSummary, createdAt, orderNo, shopOrderNo, orderType,
        displayOrderNo,
    } = order;
    return (
        <Link activityName='OrderLogActivity'
            activityParams={{ orderNo }}
            className={styles.wrapper}
            css={pressActionEffect} >
            <Column className={styles.container}
                spacing={4}
                fullWidth>
                <Column spacing={12}
                    fullWidth
                    className={styles.body} >
                    <Badge variant='outline' color={status === 'READY' ? colors.primary : colors.gray6}>
                        {t(`status.${status}`)}
                    </Badge>
                    <Text fontWeight='bold' size='xl'>{shopName}</Text>
                    <Text color={colors.gray7} className={styles.item}>
                        {t(`orderType.${orderType}`)} {(displayOrderNo || `${shopOrderNo}`).padStart(4, '0')} ·
                      &nbsp;{orderName} {optionSummary}
                    </Text>
                </Column>
                <div className={styles.footer}>
                    <Text color={colors.gray6} align='center'>
                        {dayjs(createdAt).format('YYYY.MM.DD')}
                    </Text>
                </div>
            </Column>
        </Link>
    );
}

export default OrderLog;
